import React from "react";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import messages from "./messages";

class AttentionList extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (<React.Fragment>
            {this.props.contents.map(data => {
                const isTranslate = data.translate ? <FormattedMessage {...messages[data.values]}/> : data.values;
                return <p key={data.key}>{isTranslate}</p>
            })}
        </React.Fragment>)
    }
}

AttentionList.propTypes = {
    contents: PropTypes.array.isRequired
};

export default AttentionList


// WEBPACK FOOTER //
// ./src/components/Footer/AttentionList.js